






























































import mixins from 'vue-typed-mixins';
import UserDetails from '@/components/user/UserDetails.vue';
import UserPermissions from '@/components/user/UserPermissions.vue';
import UserUtils, { User } from '@/utils/UserUtils';
import cloneDeep from 'lodash.clonedeep';
import EmailUtils, { AutomatedEmail } from '@/utils/EmailUtils';
export default mixins().extend({
  components: {
    UserDetails,
    UserPermissions,
  },

  computed: {
    emailsOptions(): any {
      return this.email.items?.map((email) => ({
        text: email.name,
        value: email,
      }));
    },
  },

  data(): {
    user: User;
    email: {
      visible: boolean;
      items?: AutomatedEmail[];
      value?: AutomatedEmail;
    };
    inprogress: boolean;
  } {
    return {
      user: {
        id: undefined,
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        email: '',
        state: 'reset_password',
        coordinates: {},
        preferences: {},
        permissions: [],
      },
      email: {
        visible: false,
        items: undefined,
        value: undefined,
      },
      inprogress: false,
    };
  },

  watch: {
    async 'email.visible'() {
      if (this.email.visible) {
        try {
          this.email.items = (await EmailUtils.api.list()).filter(
            (email) => email.type === 'user'
          );
        } catch (error) {
          (this.$refs.alert as any).show('visible', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      } else {
        this.email.items = undefined;
        this.email.value = undefined;
      }
    },
  },

  methods: {
    async submit() {
      this.inprogress = true;
      try {
        this.$alert.hide('submit');

        await UserUtils.api.add(this.user);
        await this.$router.push({ name: 'user' });

        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.user.username],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
      this.inprogress = false;
    },

    async submitAndEmail() {
      this.inprogress = true;
      try {
        this.$alert.hide('submitAndEmail');

        // store email for later and close modal
        const email = cloneDeep(this.email.value);
        this.email.visible = false;

        this.user.id = await UserUtils.api.add(this.user);

        await EmailUtils.api.send({
          emailid: email?.id,
          users: [this.user],
        });

        await this.$router.push({ name: 'user' });
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.user.username],
          }),
        });
      } catch (error) {
        this.$alert.show('submitAndEmail', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
      this.inprogress = false;
    },
  },
});
